import RecoTracking from "../RecoTracking";
import { RecommendationsTrackingDataDto } from "../RecommendationsTrackingDataDto";
import { GTMRecoTrackingInfo } from "./GTMRecoTrackingInfo";

export default class GTMRecoTracking extends RecoTracking {
  trackRecoClick(data: RecommendationsTrackingDataDto): void {
    const gtmRecoEvent: GTMRecoTrackingInfo = {
      reco_id: data.placement,
      reco_location: data.placement,
      reco_rule: data.strategie,
      event: "reco.click",
    };
    window.dataLayer?.push(gtmRecoEvent);
  }

  trackRecoImpression(
    data: RecommendationsTrackingDataDto,
    _: Array<string>,
  ): void {
    const gtmRecoEvent: GTMRecoTrackingInfo = {
      reco_id: data.placement,
      reco_location: data.placement,
      reco_rule: data.strategie,
      event: "reco.impression",
    };
    window.dataLayer?.push(gtmRecoEvent);
  }
}
